import { createFileRoute } from '@tanstack/react-router'

import { PromoPage } from '@/features/promo/promo-page'
import { promoFilters } from '@/features/promo/promo-search'

export const Route = createFileRoute('/_app/promo')({
    validateSearch: promoFilters.parse,
    component: PromoPage,
    staticData: { crumb: 'Promo codes' }
})
